import logo from './img/kosmos-logo.png'

export default () => {
    return <img src={logo} width={220} alt='kosmos logo'/>
}